import { useGridRowContext } from '../../../../_grid/contexts/rowContext';
import { EntityType } from '../../../../../../api/generated/data-contracts';

export const useRowType = () => {
    const { row } = useGridRowContext();
    const isResource = row.identity.entityType === EntityType.Resource;
	const isContract = row.identity.entityType === EntityType.Contract;
    return {
        isResource,
		isContract
    };
};
